import React, { useEffect, useState } from 'react';
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
  UpdateIcon,
} from '../../../components/mui/Buttons/Buttons';
import { Form, FormikProvider, useFormik } from 'formik';
import { Box, Stack, Switch, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { createQuarter, getAllQuarters, updateQuarter } from '../../../redux/features/appraisalSlice';

const AddQuarter = ({ dispatchParams, appraisalID, appraisalName, Tagstatus, colorTag }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.appraisal);

  const ValidationSchema = Yup.object().shape({
    appraisal_tag_name: Yup.string().required('Please enter tag name'),
    color: Yup.string().required('color is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      appraisal_tag_name: appraisalName || '',
      appraisal_tag_id: appraisalID,
      appraisal_tag_status: Tagstatus,
      color: colorTag,
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      if (appraisalID) {
        dispatch(updateQuarter(values)).then((res) => {
          if (res.payload.status === 'success') {
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
            dispatch(getAllQuarters(dispatchParams));
            setOpen(false);
          } else {
            enqueueSnackbar(res.payload.message, {
              variant: 'error',
            });
            // setOpen(false);
          }
        });
      } else {
        dispatch(createQuarter({ data: [values] })).then((res) => {
          if (res.payload.status === 'success') {
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
            dispatch(getAllQuarters(dispatchParams));
            setOpen(false);
            formik.resetForm();
          } else {
            enqueueSnackbar(res.payload.message, {
              variant: 'error',
            });
            // setOpen(false);
          }
        });
      }
    },
  });

  const handleChange = (event) => {
    formik.setFieldValue('appraisal_tag_status', event.target.checked ? 1 : 0);
  };

  return (
    <GlobalDialog
      title={appraisalID ? 'Edit Quarter' : 'Add Quarter'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'sm'}
      closeButton={true}
      popupButton={
        appraisalID ? (
          <UpdateIcon size="small" action={() => setOpen(true)}>
            Edit
          </UpdateIcon>
        ) : (
          <AddButton size="small" action={() => setOpen(true)}>
            Add Quarter
          </AddButton>
        )
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={'column'} spacing={2}>
                  <TextField
                    name="appraisal_tag_name"
                    value={formik.values.appraisal_tag_name}
                    error={formik.touched.appraisal_tag_name && Boolean(formik.errors.appraisal_tag_name)}
                    helperText={formik.errors.appraisal_tag_name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Quarter Name"
                  />
                  {appraisalID ? (
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <label>Status</label>
                      <Switch
                        checked={Boolean(formik.values.appraisal_tag_status)}
                        onChange={handleChange}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                      <span>{formik.values.appraisal_tag_status ? 'Active' : 'Inactive'}</span>
                    </Stack>
                  ) : null}
                  <TextField
                    sx={{
                      width: '100px',
                    }}
                    type="color"
                    name="color"
                    label="Color"
                    value={formik.values.color || '#000000'}
                    onChange={(e) => {
                      formik.setFieldValue('color', e.target.value);
                    }}
                    error={formik.touched.color && Boolean(formik.errors.color)}
                    helperText={formik.touched.color && formik.errors.color}
                  />
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                  <Stack direction={'row'} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? 'Please wait...' : 'Save'}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AddQuarter;
